var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"latest-news-category-slot__wrapper"},[_c('a-link',{attrs:{"to":_vm.to}},[_vm._v("\n    "+_vm._s(_vm.article.Category.Name)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }